import styled from 'styled-components';

import bg from '../../assets/images/bg.svg';

const StyledBackgroundImage = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 1600px;
	height: 1080px;
	background-image: url(${bg});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
`;

const StyledBackground = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(17, 19, 20, 0.98);
`;

export { StyledBackgroundImage, StyledBackground };
